import { ActionReducer } from '@ngrx/store';
import * as applicationList from '../actions/application-list.actions';
import * as applicationDetail from '../actions/application-detail.actions';
import * as applicationDelete from '../actions/application-delete.actions';
import * as updatePermissions from '../actions/application-update-permissions.actions';

import {
    loadingStatusAdd,
    loadingStatusRemove,
    StatusAction
} from '../../../core/reducers/loading-status.reducer';

type Actions
    = applicationList.Actions
    | applicationDetail.Actions
    | applicationDelete.Actions
    | updatePermissions.Actions;

/**
 * Loading status reducer for applications page - adds or removes loading flag from store.
 */
export const loadingStatus: ActionReducer<any> = (state: string[] = [], {type}: Actions) => {
    switch (type) {
        case applicationList.LOAD_REQUEST:
            return loadingStatusAdd(state, new StatusAction(type, applicationList.LOAD_REQUEST));
        case applicationList.LOAD_SUCCESS:
        case applicationList.LOAD_ERROR:
            return loadingStatusRemove(state, new StatusAction(type, applicationList.LOAD_REQUEST));

        case applicationDetail.LOAD_REQUEST:
            return loadingStatusAdd(state, new StatusAction(type, applicationDetail.LOAD_REQUEST));
        case applicationDetail.LOAD_SUCCESS:
        case applicationDetail.LOAD_ERROR:
            return loadingStatusRemove(state, new StatusAction(type, applicationDetail.LOAD_REQUEST));

        case applicationDelete.DELETE_REQUEST:
            return loadingStatusAdd(state, new StatusAction(type, applicationDelete.DELETE_REQUEST));
        case applicationDelete.DELETE_SUCCESS:
        case applicationDelete.DELETE_ERROR:
            return loadingStatusRemove(state, new StatusAction(type, applicationDelete.DELETE_REQUEST));

        // first initial update request; authorization iframe follows
        case updatePermissions.UPDATE_PERMISSIONS_REQUEST:
            return loadingStatusAdd(state, new StatusAction(type, updatePermissions.UPDATE_PERMISSIONS_REQUEST));
        case updatePermissions.UPDATE_PERMISSIONS_SUCCESS:
        case updatePermissions.UPDATE_PERMISSIONS_ERROR:
            return loadingStatusRemove(state, new StatusAction(type, updatePermissions.UPDATE_PERMISSIONS_REQUEST));

        // get status - finish of authorization
        case updatePermissions.UPDATE_PERMISSIONS_STATUS_REQUEST:
            return loadingStatusAdd(state, new StatusAction(type, updatePermissions.UPDATE_PERMISSIONS_STATUS_REQUEST));
        case updatePermissions.UPDATE_PERMISSIONS_STATUS_SUCCESS:
        case updatePermissions.UPDATE_PERMISSIONS_STATUS_ERROR:
            return loadingStatusRemove(state, new StatusAction(type, updatePermissions.UPDATE_PERMISSIONS_STATUS_REQUEST));

        default:
            return state;
    }
};






// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/reducers/loading-status.reducer.ts